import { Controller } from 'react-hook-form';
import { FormattedMessage } from 'react-intl';

import { RichText } from '@/components/ui/rich-text';
import { Checkbox } from '@/components/ui/checkbox';
import { Typography } from '@/components/ui/typography';

import type { ContractForm } from './types';

interface InstructionsProps {
  hookForm: ContractForm;
  html?: string | null;
  manualSetupRequired?: boolean;
}

export function Instructions({
  hookForm,
  html,
  manualSetupRequired,
}: InstructionsProps) {
  const {
    control,
    formState: { errors },
  } = hookForm;
  const followedInstructionsError = errors.followedInstructions?.message;
  const instructionsHtml = html?.trim();
  if (!instructionsHtml && !manualSetupRequired) return null;

  return (
    <div className="border-fx-neutral-200 bg-fx-neutral-50 flex flex-col items-start justify-center gap-2 self-stretch rounded-sm border p-3">
      {instructionsHtml && (
        <>
          <Typography variant="body2">
            <FormattedMessage
              defaultMessage="Instructions"
              description="Add contract sheet: heading for Vonq setup instructions block"
            />
          </Typography>
          <RichText
            html={instructionsHtml}
            openLinksInNewTab
            className="!text-fx-neutral-600 prose-p:my-1 prose-ul:my-1 prose-ol:my-1"
          />
        </>
      )}

      {manualSetupRequired && (
        <div className="flex flex-col items-start justify-center gap-2 self-stretch p-2 pl-0">
          <Controller
            control={control}
            name="followedInstructions"
            render={({ field }) => (
              <Checkbox
                checked={field.value ?? false}
                onCheckedChange={checked => field.onChange(checked === true)}
                label={
                  <Typography variant="medium1">
                    <FormattedMessage
                      defaultMessage="I understand that my contract can only be activated if I follow the instructions"
                      description="Add contract sheet: manual setup acknowledgment checkbox label"
                    />
                  </Typography>
                }
              />
            )}
          />
          {followedInstructionsError && (
            <Typography variant="small1" className="!text-fx-rose">
              {followedInstructionsError}
            </Typography>
          )}
        </div>
      )}
    </div>
  );
}
